import { CreditSubscription, DesignerSubscription, SubscriptionType, Team } from 'models';
import { SubscriptionHelpers } from 'helpers/SubscriptionHelpers';

export const getSubscriptionMeta = (team: Team) => {
    const creditPackageSubscription = team.subscriptions?.find(
        (sub) => sub.subscription === CreditSubscription.STANDARD,
    );
    const designerSubscription = team.subscriptions?.find((sub) => sub.subscription === DesignerSubscription.STANDARD);

    const creditsPerRenewal = creditPackageSubscription?.quantity ?? 0;

    const renewalDate = team.stripeSubscription?.items?.data[0]?.current_period_end
        ? new Date(team.stripeSubscription.items.data[0].current_period_end * 1000).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric',
          })
        : null;

    const hasPaidDesignerSubscription = Boolean(designerSubscription);

    const isBeingCancelled = (type: SubscriptionType) =>
        SubscriptionHelpers.isGoingToBeCanceled(type, team.subscriptionUpdateNotice?.changes ?? []);

    const cancellationDate = (type: SubscriptionType) => SubscriptionHelpers.getCancellationDate(team, type);

    const shouldShowSubscriptionInfo = (type: SubscriptionType) => {
        const isCancelled = isBeingCancelled(type);
        const cancelDate = cancellationDate(type);
        const hasSubscription = type === SubscriptionType.CREDIT ? creditPackageSubscription : true;
        return hasSubscription && ((isCancelled && cancelDate) || (!isCancelled && renewalDate));
    };

    return {
        designerSubscription,
        creditPackageSubscription,
        creditsPerRenewal,
        renewalDate,
        hasPaidDesignerSubscription,
        isBeingCancelled,
        cancellationDate,
        shouldShowSubscriptionInfo,
    };
};
